/* Label & Leaf — bundle configurator.
   Personalises a whole set on one screen: their photo + name once, then one
   row per book and the set's covers on the stage. Every bundle is for one
   child except the two-story pair, whose Book 2 may be for another child
   (owner, 2026-10-24; LLBooksOffers.requiresSingleChild).
   Their Complete Collection (kind library) is the six books in a fixed order:
   its rows name the books instead of offering a choice, and no pick or saved
   choice can change or reorder them.
   `core` is pure (state in, state out) and is unit-tested in node; `mount`
   binds it to markup and posts the v2 or six-title v3 line via
   LLBooksOffers. Two hosts (2026-09-06): the bundle product page
   (ll-storybook-bundle.liquid, which owns steps 1+2 itself) and the story
   page (ll-storybook.liquid, which passes its own child in as `primary`
   and swaps the configurator in beside its steps). */
(function () {
  'use strict';
  var offers = window.LLBooksOffers;

  /* The cover tiles read a sample name until the shopper types one, so the
     set looks like finished books rather than a template ("Their name"). */
  var DEFAULT_NAME = 'Sam';
  var SAMPLE_NAMES = { rainbow_kingdom: 'Sam', dino_herd: 'Jordan', luna_the_shy_dragon: 'Noah' };
  function coverDisplayName(name, storyId) { return name || SAMPLE_NAMES[storyId] || DEFAULT_NAME; }
  var CHAR_PLACEHOLDER = 'Their character will appear here';
  // The name tokens a cover text template may hold (as ll-storybook.js fills them).
  var NAME_TOKEN = /\[(?:NAME|CHILD(?:['’]S)?(?: NAME)?)\]/gi;
  var NAME_ONLY = /^\s*\[(?:NAME|CHILD(?:['’]S)?(?: NAME)?)\]\s*$/i;
  var COUNT_WORDS = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six'];

  function emptyChild() { return { photoFile: null, photoDataUrl: null, name: '', consent: false, ready: false }; }

  /* Their Complete Collection's books are fixed. An older ll-books-offers.js
     (a partial theme deploy) has no fixedSlots and no fixed bundle, so every
     bundle it knows keeps its book choices, as before. */
  function hasFixedSlots(lib, bundle) { return Boolean(lib && typeof lib.fixedSlots === 'function' && lib.fixedSlots(bundle)); }

  /* The book picker (owner, 2026-10-27): one section with the set's slots at
     the top and one list of every book under them. Their Complete
     Collection's six books are fixed; the retired read-and-colour set keeps
     its rows. */
  function pickerMode(bundle) {
    if (bundle && bundle.kind === 'library') return 'fixed';
    return bundle && bundle.kind === 'mixed' ? 'rows' : 'pick';
  }

  /* Preserve the old per-slot child fields for legacy cart reads. New
     bundles use only primary. */
  /* `primary` is optional: a host that owns the child (the story page's
     steps 1+2) passes its own object so a bundle swap keeps the child. A
     picked set starts with this page's book in Book 1 and every other slot
     empty, so the shopper chooses the rest. */
  function createState(bundle, catalogue, fromStoryId, primary) {
    var ids = offers.defaultStoryIds(bundle, catalogue, fromStoryId || null);
    if (pickerMode(bundle) === 'pick') ids = ids.map(function (id, i) { return i === 0 && fromStoryId && id === fromStoryId ? id : null; });
    return {
      singleChild: offers.requiresSingleChild(bundle),
      primary: primary || { photoFile: null, photoDataUrl: null, name: '', consent: false, ready: false },
      slots: ids.map(function (storyId, i) { return { index: i + 1, storyId: storyId, own: false, child: emptyChild(), colouringOwn: false, colouringChild: emptyChild() }; })
    };
  }

  /* Restore only the v2/v3 shapes emitted by this configurator. Referenced
     photos must belong to the recorded child; unsupported/old lines stop
     editing instead of silently becoming the default two books. */
  function restoreCartItem(item, bundle, catalogue, region) {
    var p = item && item.properties || {};
    if ([offers.CONTRACT, offers.FLEXIBLE_CONTRACT].indexOf(p['_Bundle contract']) < 0 || p['_Bundle ID'] !== bundle.id
      || String(item.variant_id) !== String(bundle.variantId) || !(item.quantity > 0)
      || p['_Photo consent'] !== 'adult-authority-v2026-07-21') return null;
    function child(prefix) {
      var photo = p[prefix + ' photo'];
      if (typeof photo !== 'string' || (!offers.privatePhotoReference(photo) && !/^https:\/\/cdn\.shopify\.com\/s\/files\/\d+\/\d+\/\d+\/\d+\/uploads\/[a-z0-9_.-]+(?:\?[^\s]*)?$/i.test(photo))
        || !offers.validName(p[prefix + ' child name']) || p[prefix + ' photo ref']) return null;
      // The line's _Photo consent (checked above) covers every photo on it.
      return { name: p[prefix + ' child name'], photoFile: photo, photoDataUrl: offers.privatePhotoReference(photo) ? null : photo, consent: true, ready: true };
    }
    var family = bundle.kind === 'colouring' ? catalogue.colouring : catalogue.stories;
    var prefix = bundle.kind === 'colouring' ? '_Colouring ' : '_Book ';
    var primary = child(prefix + '1');
    if (!primary) return null;
    primary.consent = true;
    var state = createState(bundle, catalogue, '', primary);
    state.slots.forEach(function (slot) { slot.storyId = p[prefix + slot.index + ' story ID']; });
    var valid = state.slots.every(function (slot) {
      var key = prefix + slot.index;
      var entry = family.filter(function (candidate) { return (bundle.kind === 'colouring' ? (candidate.colouringStoryId || candidate.storyId) : candidate.storyId) === p[key + ' story ID']; })[0];
      if (!entry || entry.handle !== p[key + ' product']) return false;
      slot.storyId = entry.storyId;
      if (slot.index > 1) {
        if (p[key + ' photo ref'] === offers.itemWord(bundle, region) + ' 1' && p[key + ' child name'] === primary.name && !p[key + ' photo']) slot.own = false;
        else { slot.child = child(key); slot.own = true; if (!slot.child) return false; }
      }
      if (bundle.kind === 'mixed') {
        var colour = offers.collectionColouring(catalogue, slot, state.slots);
        var ck = '_Colouring ' + slot.index;
        if (!colour || (colour.colouringStoryId || colour.storyId) !== p[ck + ' story ID'] || colour.handle !== p[ck + ' product']) return false;
        if (p[ck + ' photo ref'] === 'Book ' + slot.index && p[ck + ' child name'] === slotChild(state, slot).name && !p[ck + ' photo']) slot.colouringOwn = false;
        else { slot.colouringChild = child(ck); slot.colouringOwn = true; if (!slot.colouringChild) return false; }
      }
      return true;
    });
    if (!valid || new Set(state.slots.map(function (slot) { return slot.storyId; })).size !== state.slots.length) return null;
    if (p['_Bundle contract'] !== offers.bundleContract(bundle, catalogue, state.slots)) return null;
    // Only the pair's v3 line may carry a second child.
    if (p['_Bundle contract'] === offers.FLEXIBLE_CONTRACT && offers.requiresSingleChild(bundle)
      && state.slots.some(function (slot) { return slot.own || slot.colouringOwn; })) return null;
    return firstMissing(state, bundle, catalogue, region, true) ? null : state;
  }

  function cloneState(state) {
    return {
      singleChild: state.singleChild,
      primary: Object.assign({}, state.primary),
      slots: state.slots.map(function (slot) { return Object.assign({}, slot, { child: Object.assign({}, slot.child), colouringChild: Object.assign({}, slot.colouringChild || emptyChild()) }); })
    };
  }

  function otherStorySlot(state, slotIndex, storyId) {
    return state.slots.filter(function (slot) { return slot.index !== slotIndex && slot.storyId === storyId; })[0];
  }

  function pickStory(state, bundle, catalogue, slotIndex, storyId) {
    var next = cloneState(state);
    var target = next.slots[slotIndex - 1];
    if (!target || target.storyId === storyId || hasFixedSlots(offers, bundle)) return next;
    if (!offers.slotCatalogue(bundle, catalogue).some(function (entry) { return entry.storyId === storyId; })) return next;
    // A choice in one row must never silently replace another book.
    if (otherStorySlot(next, slotIndex, storyId)) return next;
    target.storyId = storyId;
    return next;
  }

  /* A tap on a book in the picker: a chosen book leaves its slot; another
     fills the lowest empty slot, or changes nothing once the set is full.
     No book is ever moved or swapped, and each slot keeps its own child. */
  function toggleStory(state, bundle, catalogue, storyId) {
    var next = cloneState(state);
    if (pickerMode(bundle) === 'fixed' || hasFixedSlots(offers, bundle)) return next;
    if (!offers.slotCatalogue(bundle, catalogue).some(function (entry) { return entry.storyId === storyId; })) return next;
    var chosen = next.slots.filter(function (slot) { return slot.storyId === storyId; })[0];
    var empty = next.slots.filter(function (slot) { return !slot.storyId; })[0];
    if (chosen) chosen.storyId = null;
    else if (empty) empty.storyId = storyId;
    return next;
  }

  function clearSlot(state, bundle, slotIndex) {
    var next = cloneState(state);
    var slot = next.slots[slotIndex - 1];
    if (slot && pickerMode(bundle) !== 'fixed' && !hasFixedSlots(offers, bundle)) slot.storyId = null;
    return next;
  }

  function remainingSlots(state) { return state.slots.filter(function (slot) { return !slot.storyId; }).length; }

  function slotTotal(bundle) { return bundle.kind === 'colouring' ? bundle.colouring : bundle.stories; }

  /* The picker's live line: what is left to choose, or that the set is full. */
  function pickStatus(state, bundle) {
    var count = state.slots.length, remaining = remainingSlots(state);
    if (pickerMode(bundle) === 'fixed') return { remaining: 0, full: true, text: 'All ' + count + ' books included' };
    if (remaining) return { remaining: remaining, full: false, text: 'Choose ' + remaining + ' more book' + (remaining === 1 ? '' : 's') };
    return { remaining: 0, full: true, text: count === 2 ? 'Both books chosen' : 'All ' + count + ' books chosen' };
  }

  // Said when a book is tapped while every slot is taken.
  var FULL_HINT = 'Both books chosen. Remove one to choose another.';
  function fullHint(bundle) { return slotTotal(bundle) > 2 ? 'All ' + slotTotal(bundle) + ' books chosen. Remove one to choose another.' : FULL_HINT; }

  function setOwn(state, slotIndex, own) {
    var next = cloneState(state);
    if (state.singleChild) return next;
    var slot = next.slots[slotIndex - 1];
    if (!slot) return next;
    slot.own = Boolean(own);
    if (!own) slot.child = emptyChild();
    return next;
  }

  function setColouringOwn(state, slotIndex, own) {
    var next = cloneState(state);
    if (state.singleChild) return next;
    var slot = next.slots[slotIndex - 1];
    if (!slot) return next;
    slot.colouringOwn = Boolean(own);
    if (!own) slot.colouringChild = emptyChild();
    return next;
  }

  function slotChild(state, slot) { return slot.own ? slot.child : state.primary; }
  /* the colouring book beside a story follows that story's child unless
     it has been given one of its own */
  function colouringChild(state, slot) { return slot.colouringOwn ? slot.colouringChild : slotChild(state, slot); }

  function colouringLabel(region) { return (region === 'US' ? 'Coloring' : 'Colouring') + ' book'; }

  function builderSlots(state, bundle, region) {
    var word = offers.itemWord(bundle, region);
    return state.slots.map(function (slot) {
      var child = slotChild(state, slot);
      var out = { index: slot.index, storyId: slot.storyId, child: { name: child.name, photoFile: child.photoFile, ref: (!slot.own && slot.index > 1) ? word + ' 1' : null } };
      if (bundle.kind === 'mixed') {
        var cc = colouringChild(state, slot);
        out.colouring = { child: { name: cc.name, photoFile: cc.photoFile, ref: slot.colouringOwn ? null : 'Book ' + slot.index } };
      }
      return out;
    });
  }

  /* booksOnly: the guided journey's book step checks the book choices alone;
     the page's own child (photo, consent) is checked when they buy (owner,
     2026-10-19: the photo can wait until Add to basket). */
  function firstMissing(state, bundle, catalogue, region, legacyRead, booksOnly) {
    var p = state.primary;
    if (!booksOnly) {
      if (!p.photoFile || !p.ready) return { slotIndex: 0, field: 'photo', message: 'Please upload their photo first.' };
      if (!p.consent) return { slotIndex: 0, field: 'consent', message: 'Please tick the box above to confirm you have authority to provide this photo.' };
      if (!p.name) return { slotIndex: 0, field: 'name', message: 'Please enter the child’s first name.' };
      if (!offers.validName(p.name)) return { slotIndex: 0, field: 'name', message: 'Please check the child’s name.' };
    }
    var word = offers.itemWord(bundle, region);
    // A picked set asks for its missing books first, in the picker's words.
    if (pickerMode(bundle) === 'pick' && remainingSlots(state)) {
      return { slotIndex: state.slots.filter(function (slot) { return !slot.storyId; })[0].index, field: 'story', message: pickStatus(state, bundle).text };
    }
    for (var i = 0; i < state.slots.length; i += 1) {
      var slot = state.slots[i];
      var label = word + ' ' + slot.index;
      if (!slot.storyId) return { slotIndex: slot.index, field: 'story', message: label + ': please choose a book.' };
      if (slot.own) {
        /* Another child's photo and tick wait for Add to basket too; the
           book step needs their name for the preview. */
        if (!booksOnly && (!slot.child.photoFile || !slot.child.ready)) return { slotIndex: slot.index, field: 'photo', message: label + ': please upload their photo.' };
        if (!slot.child.name) return { slotIndex: slot.index, field: 'name', message: label + ': please enter their name.' };
        if (!offers.validName(slot.child.name)) return { slotIndex: slot.index, field: 'name', message: label + ': please check their name.' };
        if (!booksOnly && slot.child.consent !== true) return { slotIndex: slot.index, field: 'consent', message: label + ': please tick the box to confirm you have authority to provide this photo.' };
      }
      if (bundle.kind === 'mixed' && slot.colouringOwn) {
        var cLabel = colouringLabel(region) + ' ' + slot.index;
        var cc = slot.colouringChild || emptyChild();
        if (!cc.photoFile || !cc.ready) return { slotIndex: slot.index, field: 'colouringPhoto', message: cLabel + ': please upload their photo.' };
        if (!cc.name) return { slotIndex: slot.index, field: 'colouringName', message: cLabel + ': please enter their name.' };
        if (!offers.validName(cc.name)) return { slotIndex: slot.index, field: 'colouringName', message: cLabel + ': please check their name.' };
      }
    }
    var problem = offers.validateSlots(bundle, catalogue, builderSlots(state, bundle, region), region, legacyRead, booksOnly);
    return problem ? { slotIndex: problem.index, field: 'story', message: problem.message } : null;
  }

  function isReady(state, bundle, catalogue, region) { return firstMissing(state, bundle, catalogue, region) === null; }

  /* how many different children the set is for: the primary child plus
     every story or colouring book ticked "different child" */
  function childCount(state) {
    return 1 + state.slots.filter(function (slot) { return slot.own; }).length + state.slots.filter(function (slot) { return slot.colouringOwn; }).length;
  }

  function legend(state) {
    if (state.singleChild) return '';
    var count = childCount(state);
    if (count === 1) return 'Same child in every book';
    return (COUNT_WORDS[count] || String(count)) + ' children';
  }

  /* Fits a name into its cover box: never taller than the box (leading
     included), never larger than the size the print compositor uses
     (style.sizePct of the cover height — frameHeightPx), never below the
     style's floor, and shrinking with the name's length. */
  function coverNameFontPx(style, boxWidthPx, boxHeightPx, name, frameHeightPx) {
    var leading = style.leading || 0.88;
    var max = boxHeightPx / leading;
    if (style.sizePct && frameHeightPx) max = Math.min(max, frameHeightPx * style.sizePct / 100);
    var floor = boxHeightPx * ((style.min || 26) / (style.size || 65.4));
    /* average advance per character as a fraction of the font size —
       0.55 suits the display faces on the story covers; a tracked
       grotesk (the colouring covers) passes its own via style.charWidth */
    var byWidth = (boxWidthPx / Math.max(String(name || '').length, 1)) / (style.charWidth || 0.55);
    return Math.max(floor, Math.min(max, byWidth));
  }

  function possessiveTitle(name, colouringWordCapital) {
    var owner = offers.possessive(name) || offers.possessive(DEFAULT_NAME);
    return owner + ' ' + colouringWordCapital + ' Adventure';
  }

  // The basket proof uses the selected first book, on both adds and edits.
  // Its source is the same cover geometry as the bundle preview; no child
  // photo or sample character is drawn before the illustration is created.
  function coverProof(config, bundle, first) {
    var colouring = bundle.kind === 'colouring';
    var cover = first && ((colouring ? config.colouringCovers : config.covers) || {})[first.storyId];
    if (!cover || !first.child || !first.child.name) return Promise.resolve(null);
    return new Promise(function (resolve) {
      var done = false;
      var timer = setTimeout(function () { finish(null); }, 4000);
      function finish(blob) { if (done) return; done = true; clearTimeout(timer); resolve(blob); }
      try {
        var name = colouring ? offers.possessive(first.child.name) : first.child.name;
        var lines = [{ box: cover.box, style: cover.style, text: name }].concat((cover.titles || []).map(function (line) {
          return { box: line, style: line.style, text: line.text, fixed: true };
        }));
        var bg = new Image(); bg.crossOrigin = 'anonymous';
        bg.onerror = function () { finish(null); };
        bg.onload = function () {
          if (done) return;
          var width = 1000, height = Math.round(width * bg.naturalHeight / bg.naturalWidth);
          Promise.all(lines.map(function (line) {
            var st = line.style;
            return document.fonts && document.fonts.load ? document.fonts.load((st.italic ? 'italic ' : '') + (st.weight || 400) + ' 100px "' + st.family + '"') : Promise.resolve();
          })).then(function () {
            if (done) return;
            try {
              var canvas = document.createElement('canvas'); canvas.width = width; canvas.height = height;
              var ctx = canvas.getContext('2d'); ctx.drawImage(bg, 0, 0, width, height);
              lines.forEach(function (line) {
                var box = line.box, st = line.style;
                var w = box.w * width / 100, h = box.h * height / 100;
                var size = line.fixed ? height * st.sizePct / 100 : coverNameFontPx(st, w, h, line.text, height);
                function setFont() { ctx.font = (st.italic ? 'italic ' : '') + (st.weight || 400) + ' ' + size + 'px "' + st.family + '"'; }
                setFont();
                var textLines = [line.text];
                if (line.fixed) {
                  textLines = [''];
                  line.text.split(/\s+/).forEach(function (word) {
                    var last = textLines.length - 1, next = textLines[last] ? textLines[last] + ' ' + word : word;
                    if (textLines[last] && ctx.measureText(next).width > w) textLines.push(word);
                    else textLines[last] = next;
                  });
                }
                // Measure the actual loaded face, including tracked colouring names.
                var measured = Math.max.apply(null, textLines.map(function (text) { return ctx.measureText(text).width + Math.max(0, text.length - 1) * (st.tracking || 0) * size; }));
                var scale = Math.min(1, w / measured, h / (size * (st.leading || 0.88) * textLines.length));
                if (scale < 1) { size *= scale; setFont(); }
                var tracking = (st.tracking || 0) * size;
                var metrics = ctx.measureText(line.text);
                var ascent = metrics.actualBoundingBoxAscent || size * 0.8;
                var descent = metrics.actualBoundingBoxDescent || size * 0.2;
                var leading = size * (st.leading || 0.88), extraHeight = (textLines.length - 1) * leading;
                var y = box.y * height / 100 + (box.valign === 'top' ? ascent : box.valign === 'middle' ? (h + ascent - descent - extraHeight) / 2 : h - descent - extraHeight);
                ctx.fillStyle = st.color || '#fffffa'; ctx.textAlign = 'left'; ctx.textBaseline = 'alphabetic';
                textLines.forEach(function (text) {
                  var textWidth = ctx.measureText(text).width + Math.max(0, text.length - 1) * tracking;
                  var x = box.x * width / 100 + (box.align === 'right' ? w - textWidth : box.align === 'left' ? 0 : (w - textWidth) / 2);
                  if (!tracking) ctx.fillText(text, x, y);
                  else Array.from(text).forEach(function (letter) { ctx.fillText(letter, x, y); x += ctx.measureText(letter).width + tracking; });
                  y += leading;
                });
              });
              canvas.toBlob(finish, 'image/jpeg', 0.85);
            } catch (error) { finish(null); }
          }).catch(function () { finish(null); });
        };
        bg.src = cover.bg;
      } catch (error) { finish(null); }
    });
  }

  /* "Choose another photo" sits right after a photo status line (see
     bindPhotoGate) and shows only while that line is a warning, whoever
     writes the line: both setStatus functions call this. */
  function syncPhotoRetry(node, message, kind) {
    var retry = node.nextElementSibling;
    if (retry && retry.hasAttribute && retry.hasAttribute('data-ll-photo-retry')) retry.hidden = !(kind === 'warn' && Boolean(message));
  }

  /* A status line keeps the classes its page gives it (Finding's bar line is
     .llfind__status); only the is-* state changes. */
  function setStatus(node, message, kind) {
    if (!node) return;
    node.hidden = !message;
    statusKind(node, kind);
    node.textContent = message || '';
    syncPhotoRetry(node, message, kind);
  }
  function statusKind(node, kind) {
    if (!node.className) node.className = 'llsb__upload-status';
    ['is-bad', 'is-ok', 'is-warn'].forEach(function (name) { node.classList.remove(name); });
    if (kind) node.classList.add('is-' + kind);
  }

  // The guided journey assigns saved children before using the existing v2
  // property builder. Book 1 is the reference child, regardless of entry order.
  function applyRecipients(state, children, ids, bundle) {
    if (!children.length) return state;
    function find(id) { return children.filter(function (c) { return c.id === id; })[0] || children[0]; }
    if (offers.requiresSingleChild(bundle)) {
      var shared = cloneState(state);
      shared.primary = find('primary');
      return usePrimaryChild(shared);
    }
    var primary = find(ids[0]);
    var next = cloneState(state);
    next.primary = primary;
    next.slots.forEach(function (slot, index) {
      var child = find(ids[index]);
      slot.own = child.id !== primary.id;
      slot.child = child;
      if (bundle.kind === 'mixed') {
        var colouring = find(ids[index + next.slots.length]);
        slot.colouringOwn = colouring.id !== child.id;
        slot.colouringChild = colouring;
      }
    });
    return next;
  }

  function usePrimaryChild(state) {
    var next = cloneState(state);
    next.primary = state.primary;
    next.slots.forEach(function (slot) {
      slot.own = false; slot.child = emptyChild();
      slot.colouringOwn = false; slot.colouringChild = emptyChild();
    });
    return next;
  }

  function bindPhotoGate(ui, onAccept, onReset) {
    var generation = 0;
    var photoCheck = window.LLPhotoCheck || null;
    var ALLOWED = ['image/jpeg', 'image/png', 'image/webp'];
    var MAX_BYTES = 10 * 1024 * 1024;
    var READY_COPY = 'Photo ready to use.';
    if (ui.control && photoCheck) ui.control.addEventListener('click', function () { photoCheck.warmUp(); });
    /* "Choose another photo" sits under the status line and shows only while
       it carries a warning (syncPhotoRetry, from setStatus); the photo is
       still accepted, so it is an offer. */
    var retry = document.createElement('button');
    retry.type = 'button';
    retry.className = 'll-photo-retry';
    retry.setAttribute('data-ll-photo-retry', '');
    retry.hidden = true;
    retry.textContent = 'Choose another photo';
    retry.addEventListener('click', function () {
      ui.input.click();
      if (photoCheck) photoCheck.warmUp();
    });
    if (ui.status && typeof ui.status.after === 'function') ui.status.after(retry);
    /* In a book journey the verdict, and "Choose another photo" with a
       warning, scroll just into view above the bar (2026-10-28). */
    function reveal() {
      if (!ui.status || ui.status.hidden || !ui.status.closest || !ui.status.closest('.llsj')) return;
      var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      try { (retry.hidden ? ui.status : retry).scrollIntoView({ block: 'nearest', behavior: still ? 'auto' : 'smooth' }); } catch (e) { /* older browsers: no scroll */ }
    }
    function reset(message) {
      if (ui.preview) { ui.preview.removeAttribute('src'); ui.preview.hidden = true; }
      if (ui.label) ui.label.textContent = 'Upload their photo';
      setStatus(ui.status, message || '', message ? 'bad' : '');
      onReset(message);
    }
    ui.input.addEventListener('change', function () {
      var file = ui.input.files && ui.input.files[0];
      if (!file) return;
      var mine = ++generation;
      /* A Finding book's hero may be a grown-up or a pet, so its warnings use
         neutral words; read where the upload sits when the photo is chosen. */
      var neutral = Boolean(ui.input.closest && ui.input.closest('[data-llfind]'));
      if (ui.onChecking) ui.onChecking();
      if (ALLOWED.indexOf(file.type) === -1) { reset('Please choose a JPEG, PNG or WebP image.'); ui.input.value = ''; return; }
      if (file.size > MAX_BYTES) { reset('Please choose an image smaller than 10 MB.'); ui.input.value = ''; return; }
      setStatus(ui.status, 'Checking photo…', '');
      var reader = new FileReader();
      reader.onerror = function () { if (mine === generation) reset('We couldn’t read that image. Please choose another.'); };
      reader.onload = function () {
        var probe = new Image();
        probe.onerror = function () { if (mine === generation) reset('We couldn’t read that image. Please choose another.'); };
        probe.onload = function () {
          if (mine !== generation) return;
          if (probe.naturalWidth < 500 || probe.naturalHeight < 500) { reset('That photo is too small. Please choose a clear image at least 500 × 500px.'); ui.input.value = ''; return; }
          /* No photo check (ll-photo-check.js failed to load), or one that
             throws or rejects anyway: the photo goes ahead unchecked and
             production QA checks it (owner, 2026-10-28). */
          new Promise(function (done) { done(photoCheck ? photoCheck.check(probe, { neutral: neutral }) : { level: 'ok', code: 'unchecked' }); })
            .catch(function () { return { level: 'ok', code: 'unchecked' }; })
            .then(function (verdict) {
              if (mine !== generation) return;
              if (verdict && verdict.level === 'block') { reset(verdict.message); ui.input.value = ''; reveal(); return; }
              if (ui.preview) { ui.preview.src = String(reader.result || ''); ui.preview.hidden = false; }
              if (ui.label) ui.label.textContent = 'Choose another photo';
              if (ui.control) ui.control.classList.remove('is-missing');
              var warn = Boolean(verdict && verdict.level === 'warn');
              setStatus(ui.status, warn ? verdict.message : READY_COPY, warn ? 'warn' : 'ok');
              var copy = offers.inMemoryPhoto ? offers.inMemoryPhoto(file, String(reader.result || '')) : file;
              onAccept(copy, String(reader.result || ''), verdict, probe.naturalWidth, probe.naturalHeight);
              reveal();
            });
        };
        probe.src = String(reader.result || '');
      };
      reader.readAsDataURL(file);
    });
    return { destroy: function () { generation++; }, reset: reset, showReady: function (dataUrl) {
      if (ui.preview && dataUrl) { ui.preview.src = dataUrl; ui.preview.hidden = false; }
      if (ui.label) ui.label.textContent = 'Choose another photo';
      setStatus(ui.status, READY_COPY, 'ok');
    } };
  }


  function createChildEditor(container, child, onChange) {
    container.innerHTML = '<label class="llsb__field"><span>Their first name <small class="llsb__field-hint">Up to 12 letters</small></span><input type="text" maxlength="12" autocomplete="off" data-child-name></label>'
      + '<p class="llsb__upload-status" data-child-name-status role="status" hidden></p>'
      // Consent comes before the photo, as on the story pages, so it stays in
      // view above the purchase bar instead of under a tall upload box.
      + '<label class="llsb__photo-consent"><input type="checkbox"><span>I confirm I’m 18 or over and have authority to provide this photo. See our <a href="https://www.labelandleaf.com/policies/privacy-policy">Privacy Policy</a> for details.</span></label>'
      + '<p class="llsb__upload-status" data-child-consent-status role="status" hidden></p>'
      + '<label class="llsb__upload"><input type="file" accept="image/jpeg,image/png,image/webp" class="llp-visually-hidden" aria-label="Upload their photo"><span class="llsb__upload-cta">Upload their photo</span><img alt="Selected child photo" hidden></label>'
      + '<p class="llsb__upload-status" data-child-photo-status role="status" hidden></p>';
    var name = container.querySelector('[data-child-name]');
    var nameStatus = container.querySelector('[data-child-name-status]');
    var consent = container.querySelector('input[type=checkbox]');
    var consentStatus = container.querySelector('[data-child-consent-status]');
    var photo = container.querySelector('input[type=file]');
    var photoStatus = container.querySelector('[data-child-photo-status]');
    name.value = child.name || '';
    consent.checked = child.consent === true;
    name.addEventListener('input', function () {
      child.name = name.value.trim().normalize('NFC');
      var invalid = child.name && !offers.validName(child.name);
      name.setAttribute('aria-invalid', invalid ? 'true' : 'false');
      setStatus(nameStatus, invalid ? 'Please use up to 12 Latin letters, spaces, apostrophes or hyphens.' : '', 'bad');
      onChange();
    });
    consent.addEventListener('change', function () { child.consent = consent.checked; setStatus(consentStatus, '', ''); consent.removeAttribute('aria-invalid'); onChange(); });
    var gate = bindPhotoGate({ input: photo, label: container.querySelector('.llsb__upload-cta'), preview: container.querySelector('img'), status: photoStatus, control: container.querySelector('.llsb__upload'), onChecking: function () {
      child.ready = false; child.checking = true; onChange();
    } }, function (file, data, verdict, width, height) {
      child.photoFile = file; child.photoDataUrl = data; child.photoWidth = width; child.photoHeight = height; child.ready = true; child.checking = false; onChange();
    }, function () { child.photoFile = null; child.photoDataUrl = null; child.photoWidth = null; child.photoHeight = null; child.ready = false; child.checking = false; onChange(); });
    if (child.ready && child.photoDataUrl) gate.showReady(child.photoDataUrl);
    return { restore: function () { name.value = child.name || ''; consent.checked = child.consent === true; if (child.ready && child.photoDataUrl) gate.showReady(child.photoDataUrl); onChange(); }, destroy: gate.destroy, guide: function () {
      var target = !child.name || !offers.validName(child.name) ? name : !child.photoFile || !child.ready ? photo : consent;
      if (target === name) setStatus(nameStatus, 'Please enter a valid first name, up to 12 letters.', 'bad');
      else if (target === photo) setStatus(photoStatus, child.checking ? 'Checking photo…' : 'Please add a clear photo.', child.checking ? '' : 'bad');
      else { setStatus(consentStatus, 'Please tick the box above to confirm you have authority to provide this photo.', 'bad'); consent.setAttribute('aria-invalid', 'true'); }
      target.focus({ preventScroll: true });
      (target === consent ? consentStatus : target.closest('label')).scrollIntoView({ block: 'center', behavior: 'auto' });
    } };
  }

  window.LLBundlePage = {
    core: {
      defaultName: DEFAULT_NAME,
      applyRecipients: applyRecipients,
      restoreCartItem: restoreCartItem,
      usePrimaryChild: usePrimaryChild,
      coverDisplayName: coverDisplayName,
      emptyChild: emptyChild, createState: createState, pickStory: pickStory, setOwn: setOwn, setColouringOwn: setColouringOwn,
      pickerMode: pickerMode, toggleStory: toggleStory, clearSlot: clearSlot, remainingSlots: remainingSlots, pickStatus: pickStatus, fullHint: fullHint, FULL_HINT: FULL_HINT,
      slotChild: slotChild, colouringChild: colouringChild, childCount: childCount,
      builderSlots: builderSlots, firstMissing: firstMissing, isReady: isReady, legend: legend,
      coverNameFontPx: coverNameFontPx, possessiveTitle: possessiveTitle
    },
    coverProof: coverProof,
    mount: mount,
    createChildEditor: createChildEditor
  };


  /* ================= DOM half ================= */
  /* mount(root, options): binds the configurator to markup.
       options.config     { region, cartUrl, catalogue, bundles, covers, colouringCovers, hardcover }
       options.bundle     the config.bundles entry being built
       options.offers     window.LLBooksOffers (default)
       options.primary    optional { read(): child, guide(missing): boolean } —
                          the host owns steps 1+2; absent = this module binds
                          [data-llbp-consent|photo|name] inside root itself
       options.stage / legend / slots   elements (default: data-llbp-* in root)
       options.cta        { buttons: [], status, idleLabel, storageKey, storage, guideInBar }
                          (guideInBar false: a missing book is said in the picker alone)
       options.trackContext  the analytics context of a successful add
       options.exampleCovers  true: story tiles show each book's finished
                          example cover (its catalogue image) instead of
                          the cover template with the name and a sample
                          character (the Finding page's review)
       options.lookInside optional (slot) => { href, sameTab } (a new tab unless sameTab) | { open() } | null:
                          Look inside a chosen book; options.lookLabel its words
       options.guided.addChild  optional: Book 2's Change adds the journey's second child
       options.onChange   called after every render / readiness change
     returns { setBundle, render, isReady, firstMissing, guideToMissing, add, state } */
  function mount(root, options) {
    var offers = options.offers || window.LLBooksOffers;
    if (!offers || typeof offers.requiresSingleChild !== 'function') {
      var cta = options.cta || {};
      (cta.buttons || []).forEach(function (button) { if (button) { button.disabled = true; button.textContent = 'Please refresh'; } });
      setStatus(cta.status, 'Please refresh to load the latest book options.', 'bad');
      return null;
    }
    var core = window.LLBundlePage.core;
    var config = options.config;
    var bundle = options.bundle;
    var region = config.region;
    var isUS = region === 'US';
    var colourCap = isUS ? 'Coloring' : 'Colouring';
    var catalogue = config.catalogue || { stories: [], colouring: [] };
    var photoCheck = window.LLPhotoCheck || null;
    var external = Boolean(options.primary);
    var cta = options.cta || { buttons: [] };
    var onChange = options.onChange || function () {};
    var exampleCovers = Boolean(options.exampleCovers);
    var ALLOWED = ['image/jpeg', 'image/png', 'image/webp'];
    var MAX_BYTES = 10 * 1024 * 1024;
    var READY_COPY = '✓ Lovely — this photo is ready to use.';
    var CONSENT_SUFFIX = ' Tick the box above to continue.';

    var stage = options.stage || root.querySelector('[data-llbp-stage]');
    var legendEl = options.legend || root.querySelector('[data-llbp-legend]');
    var slotsEl = options.slots || root.querySelector('[data-llbp-slots]');
    var consentInput = external ? null : root.querySelector('[data-llbp-consent]');
    var consentControl = external ? null : root.querySelector('.llcb__photo-consent');
    var nameInput = external ? null : root.querySelector('[data-llbp-name]');
    var nameStatus = external ? null : root.querySelector('[data-llbp-name-status]');
    var addStatus = cta.status || null;

    var savedBundles = {};
    var state = core.createState(bundle, catalogue, options.fromStoryId || '', external ? options.primary.read() : null);
    var editKey = !external && offers.requestedCartEdit ? offers.requestedCartEdit(window.location.hash) : null;
    var editing = editKey !== null;
    var editor = null;
    /* the host's child is read fresh before anything judges readiness */
    function sync() {
      if (options.guided) state = core.applyRecipients(state, options.guided.children(), options.guided.recipients(), bundle);
      else if (external) state.primary = options.primary.read();
      if (state.singleChild) state = core.usePrimaryChild(state);
    }

    var adderOptions = {
      tokenProperty: '_Bundle add token',
      storageKey: cta.storageKey || ('llbp:' + (config.product && config.product.handle || bundle.id) + ':pending-add'),
      storage: cta.storage || null,
      cartUrl: config.cartUrl || '/cart',
      region: region,
      controls: function () { return (cta.buttons || []).filter(Boolean); },
      statusNode: addStatus,
      tokenPrefix: 'bundle',
      available: function () { return bundle.available !== false; }
    };
    /* the host's idle label can change with the chosen bundle, so it is read
       each time the adder resets its buttons */
    Object.defineProperty(adderOptions, 'idleLabel', { get: function () { return typeof cta.idleLabel === 'function' ? cta.idleLabel() : cta.idleLabel; } });
    var cart = offers.createCartAdder(adderOptions);

    function setStatus(node, message, kind) {
      if (!node) return;
      node.hidden = !message;
      statusKind(node, kind);
      node.textContent = message || '';
      syncPhotoRetry(node, message, kind);
    }

    /* One upload control = { input, label, preview, status, control }. onAccept
       receives (file, dataUrl, verdict); onReset receives (message). */
    /* ---------- primary child (steps 1 + 2), bundle page only ---------- */
    var primaryStatus = external ? null : root.querySelector('[data-llbp-photo-status]');
    var primaryGate = null;
    /* The photo's own verdict, kept so ticking or clearing consent only adds or
       drops the consent line: a warning stays a warning, in its own words. */
    var primaryVerdict = null;
    function primaryIsWarn() { return Boolean(primaryVerdict && primaryVerdict.level === 'warn'); }
    if (!external) {
      primaryGate = bindPhotoGate({
        input: root.querySelector('[data-llbp-photo]'), label: root.querySelector('[data-llbp-photo-label]'),
        preview: root.querySelector('[data-llbp-photo-preview]'), status: primaryStatus, control: root.querySelector('.llcb__upload'),
        onChecking: function () { state.primary.ready = false; render(); }
      }, function (file, dataUrl, verdict) {
        state.primary.photoFile = file; state.primary.photoDataUrl = dataUrl; state.primary.ready = true;
        primaryVerdict = verdict;
        if (!state.primary.consent) setStatus(primaryStatus, primaryStatus.textContent + CONSENT_SUFFIX, primaryIsWarn() ? 'warn' : 'ok');
        render();
      }, function () { state.primary.photoFile = null; state.primary.photoDataUrl = null; state.primary.ready = false; primaryVerdict = null; render(); });

      consentInput.addEventListener('change', function () {
        state.primary.consent = consentInput.checked;
        if (consentControl) consentControl.classList.remove('is-missing');
        if (state.primary.photoFile && state.primary.ready) setStatus(primaryStatus, (primaryIsWarn() ? primaryVerdict.message : READY_COPY) + (consentInput.checked ? '' : CONSENT_SUFFIX), primaryIsWarn() ? 'warn' : 'ok');
        render();
      });

      nameInput.addEventListener('input', function () {
        var next = nameInput.value.trim();
        if (String.prototype.normalize) next = next.normalize('NFC');
        state.primary.name = next;
        var invalid = Boolean(next) && !offers.validName(next);
        nameInput.setAttribute('aria-invalid', invalid ? 'true' : 'false');
        setStatus(nameStatus, invalid ? 'Please use Latin letters, spaces, apostrophes and hyphens.' : '', invalid ? 'bad' : '');
        render();
      });
    }

    /* ---------- stage ---------- */
    function storyOf(id) { return catalogue.stories.filter(function (s) { return s.storyId === id; })[0] || null; }
    function colouringOf(id) { return catalogue.colouring.filter(function (c) { return c.storyId === id; })[0] || null; }

    /* Shopify CDN URLs accept a width query param; the metafield's cover
       render is a full-size original and the stage can show up to three at
       once, so cap each to a size the tile actually needs. */
    function cdnCappedUrl(url) {
      if (!url || url.indexOf('cdn.shopify.com') === -1) return url;
      return url + (url.indexOf('?') === -1 ? '?width=800' : '&width=800');
    }

    /* One positioned text box on a cover plane: geometry as a percent of the
       plane, the style's face/colour/leading. fitAllNames sizes it once the
       plane has a size. */
    function coverText(className, box, style, text, fallbackFamily) {
      var el = document.createElement('span');
      el.className = className;
      el.style.left = box.x + '%'; el.style.top = box.y + '%'; el.style.width = box.w + '%'; el.style.height = box.h + '%';
      el.style.textAlign = box.align || 'center';
      el.style.color = style.color || '#fff';
      el.style.fontFamily = "'" + style.family + "', " + fallbackFamily;
      el.style.fontWeight = String(style.weight || 400);
      el.style.fontStyle = style.italic ? 'italic' : 'normal';
      el.style.lineHeight = String(style.leading || 0.88);
      if (style.tracking) el.style.letterSpacing = String(style.tracking) + 'em';
      el.setAttribute('data-llbp-valign', box.valign || 'bottom');
      el.textContent = text;
      return el;
    }

    /* A story tile: the keyed hardcover render (config.hardcover — the
       book's own spine, page edge and shadow on a transparent ground) with the
       cover art multiplied onto its cover plane, the typed name in the
       metafield's name box, the cover's fixed title lines beneath it, and the
       matching sample character in the cover geometry. Samples remain
       display-only, just like the neighbouring colouring cover artwork. */
    function coverTile(slot, previewChild) {
      var story = storyOf(slot.storyId);
      var cover = !exampleCovers && config.covers && config.covers[slot.storyId];
      var frame = cover && config.hardcover ? config.hardcover : null;
      var name = core.coverDisplayName((previewChild || core.slotChild(state, slot)).name, slot.storyId);
      var tile = document.createElement('figure');
      tile.className = 'llbp-tile llbp-tile--story' + (frame ? ' llbp-tile--framed' : '');
      tile.setAttribute('data-llbp-tile', slot.storyId || '');
      var plane = tile;
      if (frame) {
        var book = document.createElement('img');
        book.className = 'llbp-tile__book';
        book.src = frame.src; book.alt = ''; book.width = frame.width || 874; book.height = frame.height || 879; book.decoding = 'async';
        tile.appendChild(book);
        plane = document.createElement('div');
        plane.className = 'llbp-tile__plane';
        plane.style.left = frame.plane.x + '%'; plane.style.top = frame.plane.y + '%'; plane.style.width = frame.plane.w + '%'; plane.style.height = frame.plane.h + '%';
        tile.appendChild(plane);
      }
      var img = document.createElement('img');
      img.className = frame ? 'llbp-tile__art' : '';
      img.src = cover ? cdnCappedUrl(cover.bg) : (story && story.image) || '';
      img.alt = story ? story.title : '';
      img.width = 600; img.height = 600; img.decoding = 'async';
      plane.appendChild(img);
      if (cover) {
        var box = coverText('llbp-tile__name', cover.box, cover.style, name, "'Luckiest Guy', cursive");
        plane.appendChild(box);
        fitNames.push({ box: box, plane: plane, style: cover.style, name: name });
        (cover.titles || []).forEach(function (title) {
          /* Newer covers carry their name line as a "[NAME]" template too: the
             name box above already draws it, so that line is skipped rather
             than printed over the name; any other line fills the name in. */
          if (NAME_ONLY.test(title.text)) return;
          var line = coverText('llbp-tile__title', title, title.style, String(title.text).replace(NAME_TOKEN, name), "'Luckiest Guy', cursive");
          plane.appendChild(line);
          fitNames.push({ box: line, plane: plane, style: title.style, fixed: true });
        });
        if (cover.char) {
          var sample = config.sampleCharacters && config.sampleCharacters[slot.storyId];
          var zone = document.createElement(sample ? 'img' : 'span');
          zone.className = 'llbp-tile__char' + (sample ? ' llbp-tile__char--sample' : '');
          zone.style.left = cover.char.x + '%'; zone.style.top = cover.char.y + '%'; zone.style.width = cover.char.w + '%'; zone.style.height = cover.char.h + '%';
          if (sample) {
            zone.src = sample;
            zone.alt = 'Sample character for ' + (story ? story.title : 'this story');
            zone.decoding = 'async';
          } else {
            zone.textContent = CHAR_PLACEHOLDER;
          }
          plane.appendChild(zone);
        }
      }
      return tile;
    }

    function colouringTile(slot, previewChild) {
      var book = colouringOf(slot.storyId);
      var cover = config.colouringCovers && config.colouringCovers[slot.storyId];
      var child = previewChild || (bundle.kind === 'mixed' ? core.colouringChild(state, slot) : core.slotChild(state, slot));
      var name = core.coverDisplayName(child.name, slot.storyId);
      var tile = document.createElement('figure');
      tile.className = 'llbp-tile llbp-tile--colouring';
      tile.setAttribute('data-llbp-tile', (slot.storyId || '') + '-colouring');
      var img = document.createElement('img');
      img.src = cover ? cover.bg : (book ? book.image : '');
      img.alt = book ? book.title : core.possessiveTitle(name, colourCap);
      img.width = 680; img.height = 880; img.decoding = 'async';
      tile.appendChild(img);
      if (cover) {
        /* the cover builder's name line: possessive, tracked, centred */
        var owner = offers.possessive(name) || offers.possessive(core.defaultName);
        var box = coverText('llbp-tile__name llbp-tile__name--colouring', cover.box, cover.style, owner, 'system-ui, sans-serif');
        tile.appendChild(box);
        fitNames.push({ box: box, plane: tile, style: cover.style, name: owner });
      } else {
        var cap = document.createElement('figcaption');
        cap.className = 'llbp-tile__caption';
        cap.textContent = core.possessiveTitle(name, colourCap);
        tile.appendChild(cap);
      }
      return tile;
    }

    // A slot still to choose: a dashed tile with its number, no image.
    function emptyTile(slot) {
      var tile = document.createElement('figure');
      tile.className = 'llbp-tile llbp-tile--empty';
      tile.setAttribute('data-llbp-tile', '');
      var label = document.createElement('span'); label.textContent = offers.itemWord(bundle, region) + ' ' + slot.index; tile.appendChild(label);
      return tile;
    }

    var fitNames = [];
    function fitAllNames() {
      fitNames.forEach(function (entry) {
        var w = entry.box.clientWidth, h = entry.box.clientHeight;
        var frameH = entry.plane ? entry.plane.clientHeight : 0;
        if (!w || !h) return;
        if (entry.fixed) { entry.box.style.fontSize = (frameH * (entry.style.sizePct || 0) / 100) + 'px'; return; }
        entry.box.style.fontSize = core.coverNameFontPx(entry.style, w, h, entry.name, frameH) + 'px';
      });
    }

    function renderStage() {
      if (!stage) return;
      fitNames = [];
      stage.textContent = '';
      var storyRow = document.createElement('div');
      storyRow.className = 'llbp-stage__row llbp-stage__row--stories';
      var colouringRow = document.createElement('div');
      colouringRow.className = 'llbp-stage__row llbp-stage__row--colouring';
      /* the collection's six covers stand three and three, as its listing collage does */
      var laterRow = document.createElement('div');
      laterRow.className = storyRow.className;
      state.slots.forEach(function (slot) {
        if (!slot.storyId) (bundle.kind === 'colouring' ? colouringRow : bundle.kind === 'library' && slot.index > 3 ? laterRow : storyRow).appendChild(emptyTile(slot));
        else if (bundle.kind === 'colouring') colouringRow.appendChild(colouringTile(slot));
        else (bundle.kind === 'library' && slot.index > 3 ? laterRow : storyRow).appendChild(coverTile(slot));
        if (bundle.kind === 'mixed') {
          var colouring = offers.collectionColouring(catalogue, slot, state.slots);
          if (colouring) colouringRow.appendChild(colouringTile(Object.assign({}, slot, { storyId: colouring.storyId })));
        }
      });
      if (storyRow.children.length) stage.appendChild(storyRow);
      if (laterRow.children.length) stage.appendChild(laterRow);
      if (colouringRow.children.length) stage.appendChild(colouringRow);
      fitAllNames();
      // Said only once the pair really is for two children; one child needs no caption.
      if (legendEl) { legendEl.textContent = core.legend(state); legendEl.hidden = state.singleChild || core.childCount(state) < 2; }
    }
    window.addEventListener('resize', fitAllNames);
    /* the cover art and the keyed hardcover arrive after the first render;
       the name boxes only have a size once their plane does */
    if (stage) stage.addEventListener('load', fitAllNames, true);

    /* The bundle page's gallery is sticky under the site header (which is
       sticky itself), so it needs the header's height as its offset —
       measured, because the header's height depends on the announcement bar
       and the viewport. The story page measures its own (--llp-sticky-top),
       which the CSS falls back to. */
    var siteHeader = external ? null : document.querySelector('.section-llp-header');
    function syncStickyTop() {
      if (!siteHeader) return;
      root.style.setProperty('--llbp-sticky-top', Math.round(siteHeader.getBoundingClientRect().height) + 'px');
    }
    syncStickyTop();
    if (!external) window.addEventListener('resize', syncStickyTop);

    /* ---------- step 3: the books ---------- */
    function renderSlots() {
      if (!slotsEl) return;
      if (core.pickerMode(bundle) === 'rows') renderRows(); else renderPicker();
    }

    /* The guided journey's two children: which one a book is for. Two
       children share the pair one book each, so a choice swaps the other
       (createModel.assign). */
    function recipientPicker(index, label, slotIndex, spoken) {
      var word = offers.itemWord(bundle, region);
      var children = options.guided.children();
      var field = document.createElement(children.length > 1 ? 'label' : 'div'); field.className = 'llsj-assignment';
      field.appendChild(document.createTextNode(label));
      if (children.length === 1) {
        var name = document.createElement('strong'); name.textContent = children[0].name;
        field.appendChild(name); return field;
      }
      var select = document.createElement('select'); select.setAttribute('data-llsj-recipient', String(index));
      // Each book's picker says which book it is for (the visible label alone repeats).
      select.setAttribute('aria-label', (spoken || label) + ' ' + word.toLowerCase() + ' ' + slotIndex);
      var current = options.guided.recipients()[index] || children[0].id;
      children.forEach(function (child) {
        var option = document.createElement('option'); option.value = child.id; option.textContent = child.name;
        option.selected = child.id === current; select.appendChild(option);
      });
      select.addEventListener('change', function () {
        options.guided.assign(index, select.value); render();
        // render() rebuilt the slots: keep the keyboard on this book's picker.
        var again = slotsEl.querySelector('[data-llsj-recipient="' + index + '"]');
        if (again) again.focus({ preventScroll: true });
      });
      field.appendChild(select); return field;
    }

    /* ---------- the picker (owner, 2026-10-27) ----------
       One section: the set's slots at the top ("Book 1", "Book 2"), a live
       line, then one list of every book. A tap fills the next empty slot and
       a second tap, or ✕, empties it again; a full set never swaps a book.
       The line and the cards outlive a redraw, so a screen reader hears the
       count change and keeps its place on the card it pressed. Each slot
       keeps its child (#1532): Book 2 may be for another child. */
    var pickParts = null;
    // A message in the live line's place: the full set's hint, for the redraw
    // its tap starts, or what a refused Add is waiting for (missing), until
    // it is put right.
    var pickNote = null, pickNoteTap = false;
    function shortTitle(entry) { return entry.title.replace(/ (Colouring|Coloring) Adventure$/, ''); }
    function pickFamily() { return bundle.kind === 'colouring' ? catalogue.colouring : catalogue.stories; }
    // One child for every book: the line names them once, the slots never.
    function pickWho() { return state.singleChild && offers.validName(state.primary.name) ? ' for ' + state.primary.name : ''; }
    function renderPicker() {
      var mode = core.pickerMode(bundle), word = offers.itemWord(bundle, region);
      var family = pickFamily(), signature = mode + '|' + family.map(function (entry) { return entry.storyId; }).join(',');
      if (!pickParts || pickParts.signature !== signature || pickParts.root.parentNode !== slotsEl) {
        slotsEl.textContent = '';
        var pick = document.createElement('div'); pick.className = 'llbp-pick llbp-pick--' + mode; pick.setAttribute('data-llbp-pick', '');
        var list = document.createElement('ol'); list.className = 'llbp-pick__slots'; list.setAttribute('aria-label', 'Your books'); pick.appendChild(list);
        /* The count is the live region; the child's name follows it outside,
           so typing a name is not read out letter by letter. */
        var line = document.createElement('p'); line.className = 'llbp-pick__status'; line.setAttribute('data-llbp-pick-status', '');
        var live = document.createElement('span'); live.setAttribute('data-llbp-pick-live', ''); live.setAttribute('role', 'status'); live.setAttribute('aria-live', 'polite'); line.appendChild(live);
        var who = document.createElement('span'); who.className = 'llbp-pick__who'; line.appendChild(who);
        pick.appendChild(line);
        var cards = {};
        if (mode !== 'fixed') {
          var group = document.createElement('div'); group.className = 'llbp-pick__list'; group.setAttribute('role', 'group');
          group.setAttribute('aria-label', 'All books'); group.setAttribute('data-llbp-pick-list', '');
          family.forEach(function (entry) {
            var card = document.createElement('button'); card.type = 'button'; card.className = 'llbp-chip llbp-chip--pick';
            card.setAttribute('data-llbp-story', entry.storyId);
            var image = document.createElement('img'); image.src = entry.image || ''; image.alt = ''; image.width = 160; image.height = 160; image.decoding = 'async'; card.appendChild(image);
            var title = document.createElement('span'); title.className = 'llbp-chip__title'; title.textContent = shortTitle(entry); card.appendChild(title);
            card.addEventListener('click', function () { toggleBook(entry.storyId); });
            cards[entry.storyId] = { card: card, title: title.textContent };
            group.appendChild(card);
          });
          pick.appendChild(group);
        }
        slotsEl.appendChild(pick);
        pickParts = { signature: signature, root: pick, list: list, line: line, live: live, who: who, cards: cards };
      }
      var keep = slotFocus();
      pickParts.list.textContent = '';
      state.slots.forEach(function (slot) { pickParts.list.appendChild(pickSlot(slot, word, mode)); });
      Object.keys(pickParts.cards).forEach(function (storyId) {
        var slot = state.slots.filter(function (candidate) { return candidate.storyId === storyId; })[0];
        var parts = pickParts.cards[storyId];
        parts.card.setAttribute('aria-pressed', slot ? 'true' : 'false');
        /* The pressed card and the slots above say which books are chosen; no
           badge over the cover (owner, 2026-10-28: no information overload).
           Assistive tech hears its slot in the card's name ("Dino Herd, Book 2"). */
        if (slot) parts.card.setAttribute('aria-label', parts.title + ', ' + word + ' ' + slot.index); else parts.card.removeAttribute('aria-label');
      });
      // A full set shows it before the next tap: the books not chosen step back.
      pickParts.root.classList.toggle('is-full', mode === 'pick' && core.pickStatus(state, bundle).full);
      // The hint answers one tap; any other redraw (Look inside, child details) drops it.
      if (pickNote && !pickNote.missing && !pickNoteTap) pickNote = null;
      pickNoteTap = false;
      syncPickLine();
      if (keep) restoreSlotFocus(keep);
    }
    function syncPickLine() {
      if (!pickParts) return;
      // A refused Add's message stays only while it is still what is missing.
      if (pickNote && pickNote.missing) {
        var now = core.firstMissing(state, bundle, catalogue, region, undefined, pickNote.booksOnly);
        if (!now || now.message !== pickNote.text) dropNote();
      }
      var text = pickNote ? pickNote.text : core.pickStatus(state, bundle).text, who = pickNote ? '' : pickWho();
      if (pickParts.live.textContent !== text) pickParts.live.textContent = text;
      if (pickParts.who.textContent !== who) pickParts.who.textContent = who;
      pickParts.line.classList.toggle('is-missing', Boolean(pickNote && pickNote.missing));
    }
    /* The same words again (a second tap on a full set) are said again: the
       live region is emptied, then refilled once a screen reader has seen it
       change. */
    function sayAgain() {
      if (!pickParts) return;
      var text = pickParts.live.textContent, live = pickParts.live;
      live.textContent = '';
      setTimeout(function () { if (!live.textContent) live.textContent = text; }, 120);
    }
    /* A refused Add's message also leaves the bar once it is put right,
       unless something newer has been written there. */
    function dropNote() {
      if (pickNote && pickNote.missing && addStatus && addStatus.textContent === pickNote.text) setStatus(addStatus, '', '');
      pickNote = null;
    }
    function pickSlot(slot, word, mode) {
      var item = bundle.kind === 'colouring' ? colouringOf(slot.storyId) : storyOf(slot.storyId);
      var li = document.createElement('li');
      li.className = 'llbp-pick__slot' + (item ? '' : ' is-empty') + (slot.own ? ' is-own' : '')
        + (!item && pickNote && pickNote.missing && pickNote.field === 'story' ? ' is-missing' : '');
      li.setAttribute('data-llbp-slot', String(slot.index));
      li.setAttribute('data-llbp-slot-story', slot.storyId || '');
      var cover = document.createElement(item ? 'img' : 'span'); cover.className = 'llbp-pick__cover';
      if (item) { cover.src = item.image || ''; cover.alt = ''; cover.width = 112; cover.height = 112; cover.decoding = 'async'; }
      else cover.setAttribute('aria-hidden', 'true');
      li.appendChild(cover);
      var text = document.createElement('div'); text.className = 'llbp-pick__text';
      var label = document.createElement('span'); label.className = 'llbp-pick__label'; label.textContent = word + ' ' + slot.index; text.appendChild(label);
      var title = document.createElement('span'); title.className = item ? 'llbp-pick__title' : 'llbp-pick__empty';
      title.textContent = item ? shortTitle(item) : 'Choose a book'; text.appendChild(title);
      var who = forLine(slot, word);
      if (who) text.appendChild(who);
      li.appendChild(text);
      var actions = document.createElement('div'); actions.className = 'llbp-pick__actions';
      var look = item ? lookControl(slot) : null;
      if (look) actions.appendChild(look);
      if (item && mode !== 'fixed') {
        var remove = document.createElement('button'); remove.type = 'button'; remove.className = 'llbp-pick__remove';
        remove.setAttribute('aria-label', 'Remove ' + shortTitle(item) + ' from ' + word + ' ' + slot.index);
        remove.textContent = '✕';
        remove.addEventListener('click', function () { clearBook(slot.index); });
        actions.appendChild(remove);
      }
      if (actions.children.length) li.appendChild(actions);
      // #1532's own child for this book: their tick, then name, consent and photo.
      if (slot.own && slot.index > 1 && !state.singleChild && !options.guided) {
        var own = document.createElement('div'); own.className = 'llbp-pick__own';
        own.appendChild(ownPane(slot, slot.child, true, 'slot', function (index) { return state.slots[index - 1].child; }));
        var same = document.createElement('button'); same.type = 'button'; same.className = 'llsj-link llbp-pick__same';
        same.setAttribute('data-llbp-own-undo', '');
        same.textContent = 'Same child as ' + word + ' 1';
        same.addEventListener('click', function () { setOwnChild(slot.index, false); });
        own.appendChild(same);
        li.appendChild(own);
      }
      return li;
    }
    /* Who a book is for. One child for the whole set: nobody (the live line
       names them). Book 1: the page's child. A later book: the same child
       with Change, which gives it a child of its own (#1532's fields, or
       the journey's second child); two children in the journey choose from
       their names. */
    function forLine(slot, word) {
      if (state.singleChild) return null;
      var line = document.createElement('span'); line.className = 'llbp-pick__for';
      var guidedChildren = options.guided ? options.guided.children() : null;
      if (guidedChildren && guidedChildren.length > 1) {
        line.appendChild(recipientPicker(slot.index - 1, 'for', slot.index, bundle.kind === 'colouring' ? colourCap + ' book for' : 'Storybook for'));
        return line;
      }
      // One child: a slot still to fill says only that; who it is for comes with its book.
      if (!slot.storyId) return null;
      var first = guidedChildren ? guidedChildren[0] || {} : state.primary;
      // A book with its own child shows their fields, whose name says who it is for.
      if (slot.own) return null;
      line.textContent = offers.validName(first.name) ? 'for ' + first.name : slot.index > 1 ? 'Same child as ' + word + ' 1' : '';
      var canChange = slot.index > 1 && (options.guided ? typeof options.guided.addChild === 'function' : true);
      if (canChange) {
        var dot = document.createElement('span'); dot.setAttribute('aria-hidden', 'true'); dot.textContent = ' · '; line.appendChild(dot);
        var change = document.createElement('button'); change.type = 'button'; change.className = 'llsj-link llbp-pick__change';
        change.setAttribute('data-llbp-pick-change', '');
        change.setAttribute('aria-label', 'Change who ' + word + ' ' + slot.index + ' is for');
        change.textContent = 'Change';
        change.addEventListener('click', function () { if (options.guided) options.guided.addChild(slot.index); else setOwnChild(slot.index, true); });
        line.appendChild(change);
      }
      return line.textContent ? line : null;
    }
    /* Look inside one chosen book, where the host can show it: a page of its
       own (a new tab) or a view the host opens. */
    function lookControl(slot) {
      var target = typeof options.lookInside === 'function' ? options.lookInside(slot) : null;
      if (!target) return null;
      var control;
      var newTab = Boolean(target.href) && !target.sameTab;
      if (target.href) {
        control = document.createElement('a'); control.setAttribute('href', target.href);
        control.appendChild(document.createTextNode(options.lookLabel || 'Look inside'));
        if (newTab) {
          control.setAttribute('target', '_blank'); control.setAttribute('rel', 'noopener');
          var hint = document.createElement('span'); hint.className = 'llp-visually-hidden'; hint.textContent = ' (opens in a new tab)'; control.appendChild(hint);
        }
      } else if (typeof target.open === 'function') {
        control = document.createElement('button'); control.type = 'button'; control.textContent = options.lookLabel || 'Look inside';
        control.addEventListener('click', function () { target.open(); });
      } else return null;
      control.className = 'llsj-link llbp-pick__look';
      control.setAttribute('data-llbp-look', '');
      // Several books each have one: the name says which.
      var item = bundle.kind === 'colouring' ? colouringOf(slot.storyId) : storyOf(slot.storyId);
      if (item) control.setAttribute('aria-label', (options.lookLabel || 'Look inside') + ' ' + shortTitle(item) + (newTab ? ' (opens in a new tab)' : ''));
      return control;
    }
    function focusQuietly(node) { if (node && typeof node.focus === 'function') node.focus({ preventScroll: true }); }
    function focusCard(storyId) { focusQuietly(pickParts && pickParts.cards[storyId] && pickParts.cards[storyId].card); }
    function toggleBook(storyId) {
      if (core.pickerMode(bundle) === 'fixed') return;
      sync();
      var next = core.toggleStory(state, bundle, catalogue, storyId);
      var changed = next.slots.some(function (slot, i) { return slot.storyId !== state.slots[i].storyId; });
      state = next;
      var repeat = !changed && pickNote && pickNote.text === core.fullHint(bundle);
      dropNote();
      if (!changed && core.pickStatus(state, bundle).full) { pickNote = { text: core.fullHint(bundle) }; pickNoteTap = true; }
      render();
      if (repeat) sayAgain();
      focusCard(storyId);
    }
    function clearBook(index) {
      var slot = state.slots[index - 1];
      if (!slot || !slot.storyId || core.pickerMode(bundle) === 'fixed') return;
      var storyId = slot.storyId;
      state = core.clearSlot(state, bundle, index); dropNote();
      render();
      focusCard(storyId);
    }
    function setOwnChild(index, own) {
      state = core.setOwn(state, index, own); render();
      var slot = slotsEl.querySelector('[data-llbp-slot="' + index + '"]');
      focusQuietly(slot && slot.querySelector(own ? '[data-llbp-slot-name]' : '[data-llbp-pick-change]'));
    }
    /* A redraw rebuilds the slots: a control inside one with focus gets it
       back on its new self (a choice on the stage, the journey's sync). */
    var SLOT_CONTROLS = ['data-llbp-slot-name', 'data-llbp-slot-consent', 'data-llbp-slot-photo', 'data-llbp-own', 'data-llbp-own-undo', 'data-llbp-pick-change', 'data-llbp-look', 'data-llsj-recipient'];
    function slotFocus() {
      var active = document.activeElement;
      var slot = active && active.closest && pickParts && pickParts.list.contains(active) ? active.closest('[data-llbp-slot]') : null;
      if (!slot) return null;
      var key = SLOT_CONTROLS.filter(function (name) { return active.hasAttribute && active.hasAttribute(name); })[0] || (active.classList.contains('llbp-pick__remove') ? 'remove' : '');
      return key ? { slot: slot.getAttribute('data-llbp-slot'), key: key } : null;
    }
    function restoreSlotFocus(keep) {
      var slot = slotsEl.querySelector('[data-llbp-slot="' + keep.slot + '"]');
      var again = slot && slot.querySelector(keep.key === 'remove' ? '.llbp-pick__remove' : '[' + keep.key + ']');
      if (again && document.activeElement !== again) focusQuietly(again);
    }

    /* The retired read-and-colour set keeps a row per book. */
    function renderRows() {
      pickParts = null;
      slotsEl.textContent = '';
      var pickable = !hasFixedSlots(offers, bundle);
      var word = offers.itemWord(bundle, region);
      state.slots.forEach(function (slot) {
        var item = bundle.kind === 'colouring' ? colouringOf(slot.storyId) : storyOf(slot.storyId);
        var row = document.createElement('section');
        row.className = 'llbp-row' + (slot.own ? ' is-own' : '');
        row.setAttribute('data-llbp-slot', String(slot.index));
        var head = document.createElement('div');
        head.className = 'llbp-row__head';
        var thumb = document.createElement('img');
        thumb.className = 'llbp-row__thumb'; thumb.alt = ''; thumb.width = 56; thumb.height = 56; thumb.src = item ? item.image : '';
        head.appendChild(thumb);
        var label = document.createElement('span');
        label.className = 'llbp-row__label'; label.textContent = word + ' ' + slot.index + (item && item.title ? ' - ' + item.title : '');
        head.appendChild(label);
        if (pickable) {
          var chips = document.createElement('div');
          chips.className = 'llbp-chips'; chips.setAttribute('role', 'radiogroup'); chips.setAttribute('aria-label', 'Story for ' + word.toLowerCase() + ' ' + slot.index);
          (bundle.kind === 'colouring' ? catalogue.colouring : catalogue.stories).forEach(function (entry) {
            var chip = document.createElement('button');
            chip.type = 'button'; chip.className = 'llbp-chip'; chip.setAttribute('role', 'radio');
            chip.setAttribute('data-llbp-story', entry.storyId);
            var chosen = entry.storyId === slot.storyId;
            var other = otherStorySlot(state, slot.index, entry.storyId);
            chip.setAttribute('aria-checked', chosen ? 'true' : 'false');
            chip.tabIndex = chosen ? 0 : -1;
            chip.disabled = Boolean(other);
            if (other) {
              chip.setAttribute('aria-disabled', 'true');
              chip.title = 'Selected for ' + word.toLowerCase() + ' ' + other.index;
              chip.setAttribute('aria-label', entry.title + ' — ' + chip.title);
            }
            var ci = document.createElement('img'); ci.src = entry.image || ''; ci.alt = ''; ci.width = 40; ci.height = 40; chip.appendChild(ci);
            var ct = document.createElement('span'); ct.textContent = entry.title.replace(/ (Colouring|Coloring) Adventure$/, ''); chip.appendChild(ct);
            // A story already chosen for another book says which (it otherwise reads as unavailable).
            if (other) { var taken = document.createElement('small'); taken.className = 'llbp-chip__taken'; taken.textContent = word + ' ' + other.index; chip.appendChild(taken); }
            chip.addEventListener('click', function () {
              if (chip.disabled) return;
              state = core.pickStory(state, bundle, catalogue, slot.index, entry.storyId);
              render();
              var selected = slotsEl.querySelector('[data-llbp-slot="' + slot.index + '"] [aria-checked="true"]');
              if (selected) selected.focus({ preventScroll: true });
            });
            chips.appendChild(chip);
          });
          chips.addEventListener('keydown', function (event) {
            var direction = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[event.key];
            if (!direction) return;
            var enabled = Array.prototype.slice.call(chips.querySelectorAll('button:not(:disabled)'));
            var index = enabled.indexOf(event.target);
            if (index < 0) return;
            event.preventDefault();
            enabled[(index + direction + enabled.length) % enabled.length].click();
          });
          head.appendChild(chips);
        }
        row.appendChild(head);
        if (state.singleChild) {
          if (bundle.kind === 'mixed') {
            var matching = offers.collectionColouring(catalogue, slot, state.slots);
            var included = document.createElement('p'); included.className = 'llbp-row__colouring-title';
            included.textContent = '+ ' + (matching ? matching.title : colourCap + ' book');
            row.appendChild(included);
          }
          slotsEl.appendChild(row);
          return;
        }
        if (options.guided) {
          if (options.guided.children().length > 1 || bundle.kind === 'mixed') {
            row.appendChild(recipientPicker(slot.index - 1, bundle.kind === 'colouring' ? colourCap + ' book for' : 'Storybook for', slot.index));
            if (bundle.kind === 'mixed') row.appendChild(recipientPicker(slot.index - 1 + state.slots.length, colourCap + ' book for', slot.index));
          }
          slotsEl.appendChild(row);
          return;
        }
        if (slot.index > 1) {
          row.appendChild(ownTick(slot.own, 'Different child for this book', 'own', function (checked) {
            state = core.setOwn(state, slot.index, checked); render();
            if (checked) { var n = slotsEl.querySelector('[data-llbp-slot="' + slot.index + '"] [data-llbp-slot-name]'); if (n) n.focus({ preventScroll: true }); }
          }));
          row.appendChild(ownPane(slot, slot.child, slot.own, 'slot', function (index) { return state.slots[index - 1].child; }));
        }
        if (bundle.kind === 'mixed') {
          /* the matching colouring book: follows this story's child unless
             it is given one of its own — so a full set can be six children */
          var book = colouringOf(slot.storyId);
          var sub = document.createElement('div');
          sub.className = 'llbp-row__colouring' + (slot.colouringOwn ? ' is-own' : '');
          sub.setAttribute('data-llbp-colouring-row', '');
          var line = document.createElement('p');
          line.className = 'llbp-row__colouring-title';
          line.textContent = '+ ' + (book ? book.title : colourCap + ' book') + (slot.colouringOwn ? '' : ', same child');
          sub.appendChild(line);
          sub.appendChild(ownTick(slot.colouringOwn, 'Different child for this ' + colourCap.toLowerCase() + ' book', 'colouring-own', function (checked) {
            state = core.setColouringOwn(state, slot.index, checked); render();
            if (checked) { var n = slotsEl.querySelector('[data-llbp-slot="' + slot.index + '"] [data-llbp-colouring-name]'); if (n) n.focus({ preventScroll: true }); }
          }));
          sub.appendChild(ownPane(slot, slot.colouringChild || core.emptyChild(), slot.colouringOwn, 'colouring', function (index) { return state.slots[index - 1].colouringChild; }));
          row.appendChild(sub);
        }
        slotsEl.appendChild(row);
      });
    }

    function ownTick(checked, label, key, onChange) {
      var tick = document.createElement('label');
      tick.className = 'llbp-row__own';
      var cb = document.createElement('input'); cb.type = 'checkbox'; cb.checked = checked; cb.setAttribute('data-llbp-' + key, '');
      cb.addEventListener('change', function () { onChange(cb.checked); });
      tick.appendChild(cb);
      tick.appendChild(document.createTextNode(' ' + label));
      return tick;
    }

    /* The upload + name pane for a "different child". `key` is 'slot' (the
       story's own child) or 'colouring' (the colouring book's own child) and
       prefixes the data attributes guideToMissing looks for; `childOf(index)`
       looks the child up fresh off the current state — see the gate note. */
    function ownPane(slot, child, open, key, childOf) {
      var pane = document.createElement('div');
      pane.className = 'llbp-own'; pane.setAttribute('data-llbp-' + (key === 'slot' ? 'own' : key) + '-pane', ''); pane.hidden = !open;
      var up = document.createElement('label'); up.className = 'llsb__upload llcb__upload llbp-own__upload' + (key === 'colouring' ? ' llbp-own__upload--colouring' : '');
      var input = document.createElement('input'); input.type = 'file'; input.accept = 'image/jpeg,image/png,image/webp'; input.className = 'llp-visually-hidden'; input.setAttribute('data-llbp-' + key + '-photo', '');
      var upLabel = document.createElement('span'); upLabel.className = 'llsb__upload-cta'; upLabel.setAttribute('data-llbp-' + key + '-photo-label', ''); upLabel.textContent = child.photoFile ? 'Choose another photo' : 'Upload their photo';
      var upPreview = document.createElement('img'); upPreview.alt = ''; upPreview.width = 320; upPreview.height = 320; upPreview.hidden = !child.photoDataUrl; if (child.photoDataUrl) upPreview.src = child.photoDataUrl; upPreview.setAttribute('data-llbp-' + key + '-photo-preview', '');
      up.appendChild(input); up.appendChild(upLabel); up.appendChild(upPreview);
      var upStatus = document.createElement('p'); upStatus.className = 'llsb__upload-status'; upStatus.hidden = true; upStatus.setAttribute('role', 'status'); upStatus.setAttribute('aria-live', 'polite'); upStatus.setAttribute('data-llbp-' + key + '-photo-status', '');
      var field = document.createElement('label'); field.className = 'llsb__field llcb__field';
      var fl = document.createElement('span'); fl.textContent = 'Child’s name '; var em = document.createElement('em'); em.textContent = '*'; fl.appendChild(em); field.appendChild(fl);
      var nm = document.createElement('input'); nm.type = 'text'; nm.maxLength = 12; nm.autocomplete = 'off'; nm.placeholder = 'e.g. ' + core.defaultName; nm.value = child.name; nm.setAttribute('data-llbp-' + key + '-name', '');
      nm.addEventListener('input', function () {
        var next = nm.value.trim(); if (String.prototype.normalize) next = next.normalize('NFC');
        childOf(slot.index).name = next;
        renderStage(); syncCta();
      });
      field.appendChild(nm);
      /* Each photo has its own authority tick, worded as the first child's.
         Both page families' stylesheets know one of these classes. */
      var consent = document.createElement('label'); consent.className = 'llsb__photo-consent llcb__photo-consent';
      var tick = document.createElement('input'); tick.type = 'checkbox'; tick.checked = child.consent === true; tick.setAttribute('data-llbp-' + key + '-consent', '');
      tick.addEventListener('change', function () {
        childOf(slot.index).consent = tick.checked; consent.classList.remove('is-missing');
        if (tick.checked && /please tick/i.test(upStatus.textContent)) setStatus(upStatus, '', '');
        syncCta();
      });
      var consentText = document.createElement('span'); consentText.appendChild(document.createTextNode('I confirm I’m 18 or over and have authority to provide this photo. See our '));
      var policy = document.createElement('a'); policy.href = 'https://www.labelandleaf.com/policies/privacy-policy'; policy.textContent = 'Privacy Policy'; consentText.appendChild(policy);
      consentText.appendChild(document.createTextNode(' for details.'));
      consent.appendChild(tick); consent.appendChild(consentText);
      // Their name, then the tick, then the photo, as on the first child's step.
      pane.appendChild(field); pane.appendChild(consent); pane.appendChild(up); pane.appendChild(upStatus);
      /* The row this gate was bound to may already be gone by the time the
         async check resolves (a pick/tick/primary edit re-rendered every
         row in the meantime) — so the callbacks below never touch the
         captured nodes directly. They write the outcome onto the child
         (looked up fresh, by index, off the current `state`) and call
         renderSlots(), which rebuilds every row — including this one,
         wherever it now lives — from that state. */
      /* The photo's verdict is kept on the child, so a gentle warning and its
         "Choose another photo" survive every redraw instead of turning into
         the ready line. */
      bindPhotoGate({ input: input, label: upLabel, preview: upPreview, status: upStatus, control: up }, function (file, dataUrl, verdict) {
        var c = childOf(slot.index); c.photoFile = file; c.photoDataUrl = dataUrl; c.ready = true; c.error = ''; c.verdict = verdict || null; renderSlots(); renderStage(); syncCta();
      }, function (message) {
        var c = childOf(slot.index); c.photoFile = null; c.photoDataUrl = null; c.ready = false; c.error = message || ''; c.verdict = null; renderSlots(); renderStage(); syncCta();
      });
      // Drawn after the gate, whose "Choose another photo" follows this line.
      var warn = Boolean(child.verdict && child.verdict.level === 'warn' && child.verdict.message);
      if (child.error) setStatus(upStatus, child.error, 'bad');
      else if (child.ready) setStatus(upStatus, warn ? child.verdict.message : READY_COPY, warn ? 'warn' : 'ok');
      return pane;
    }

    /* The Add buttons stay clickable whenever the variant is buyable, so a
       click with something missing runs guideToMissing (red copy, scroll,
       focus) instead of a dead button; they are disabled only when the
       variant itself is unavailable. */
    function syncCta() {
      sync();
      var previewEmail = root.querySelector('[data-llbp-preview-email]');
      if (previewEmail) previewEmail.hidden = !state.primary.photoFile || !state.primary.ready;
      if (editing && (attaching || !editor || editor.phase() !== 'ready')) {
        root.querySelectorAll('input, button').forEach(function (node) { node.disabled = true; });
        (cta.buttons || []).forEach(function (node) { if (node) node.disabled = true; });
        return;
      }
      if (!cart.isAdding() && !cart.pending()) {
        (cta.buttons || []).forEach(function (b) { if (b) b.disabled = bundle.available === false; });
      }
      root.classList.toggle('is-ready', core.isReady(state, bundle, catalogue, region));
      syncPickLine();
      onChange();
    }

    function render() { sync(); renderStage(); renderSlots(); syncCta(); }

    function guideToMissing(guide) {
      sync();
      var missing = core.firstMissing(state, bundle, catalogue, region, undefined, Boolean(guide && guide.booksOnly));
      if (!missing) return false;
      if (missing.slotIndex === 0 && external) {
        /* the host owns steps 1+2 and walks the shopper there itself */
        if (options.primary.guide) options.primary.guide(missing);
        return true;
      }
      var target, statusNode, control;
      if (missing.slotIndex === 0) {
        target = missing.field === 'name' ? nameInput : (missing.field === 'consent' ? consentInput : root.querySelector('[data-llbp-photo]'));
        statusNode = missing.field === 'name' ? nameStatus : primaryStatus;
        control = missing.field === 'consent' ? consentControl : (missing.field === 'photo' ? root.querySelector('.llcb__upload') : null);
      } else {
        var row = slotsEl.querySelector('[data-llbp-slot="' + missing.slotIndex + '"]');
        var colouringMiss = missing.field === 'colouringPhoto' || missing.field === 'colouringName';
        var key = colouringMiss ? 'colouring' : 'slot';
        var wantsName = missing.field === 'name' || missing.field === 'colouringName';
        target = row && row.querySelector(wantsName ? '[data-llbp-' + key + '-name]' : missing.field === 'story' ? '.llbp-chip' : missing.field === 'consent' ? '[data-llbp-slot-consent]' : '[data-llbp-' + key + '-photo]');
        /* the pane's status line follows its name, tick and upload, so it
           serves all three; a missing photo outlines the upload box and a
           missing tick its own line */
        statusNode = row && row.querySelector('[data-llbp-' + key + '-photo-status]');
        /* A missing book is said in the picker's live line, until it is put
           right, and takes focus to the first book not yet chosen. A book's
           own child is said once, by its own status line beside the fields. */
        if (pickParts && (missing.field === 'story' || !statusNode)) {
          pickNote = { text: missing.message, missing: true, field: missing.field, booksOnly: Boolean(guide && guide.booksOnly) };
          syncPickLine();
          if (missing.field === 'story') Array.prototype.forEach.call(pickParts.list.querySelectorAll('.llbp-pick__slot.is-empty'), function (slot) { slot.classList.add('is-missing'); });
          if (missing.field === 'story') target = pickParts.root.querySelector('[data-llbp-pick-list] [aria-pressed="false"]');
        }
        control = (missing.field === 'photo' || missing.field === 'colouringPhoto') ? row && row.querySelector(colouringMiss ? '.llbp-own__upload--colouring' : '.llbp-own__upload:not(.llbp-own__upload--colouring)')
          : missing.field === 'consent' && target ? target.closest('label') : null;
        // A host whose basket line sits away from its bar (the story journey) keeps a missing book's message in the picker alone; without a picker the bar still says it.
        if (missing.field === 'story') { if (cta.guideInBar !== false || !pickParts) setStatus(addStatus, missing.message, 'bad'); statusNode = null; }
      }
      if (statusNode) setStatus(statusNode, missing.message, 'bad');
      if (control) control.classList.add('is-missing');
      if (target && (missing.field === 'name' || missing.field === 'colouringName') && target.setAttribute) target.setAttribute('aria-invalid', 'true');
      /* A missing book brings its red slot into view, the picker's line and
         the first free book just below it; a slot already in sight (clear of
         the header and the bar) stays put. Anything else is centred. */
      var missingSlot = missing.field === 'story' && pickParts ? pickParts.list.querySelector('.llbp-pick__slot.is-missing') : null;
      var step = missingSlot || (target && target.closest ? (target.closest('.llcb__step') || target.closest('.llsb__step') || target.closest('.llbp-row') || target.closest('.llbp-pick__slot')) : null);
      if (step) step.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: missingSlot ? 'nearest' : 'center' });
      if (target && typeof target.focus === 'function') target.focus({ preventScroll: true });
      return true;
    }

    /* Edit mode's controls follow the editor's phase. A photo upload that
       fails before the editor saves never changes that phase, so the upload
       failure puts the phase's labels back itself (never "Saving…"). */
    function showEditPhase(phase) {
      var disabled = phase !== 'ready';
      root.querySelectorAll('input, button').forEach(function (node) { node.disabled = disabled; });
      (cta.buttons || []).forEach(function (node) { if (node) { node.disabled = disabled || bundle.available === false; node.textContent = phase === 'loading' ? 'Loading…' : phase === 'saving' ? 'Saving…' : 'Save changes'; } });
    }

    /* The basket shows the first book with their photo in the cover's
       character zone, on this device only; the uploaded cover stays
       photo-free (ll-books-offers.js). */
    function rememberPhotoCover(properties, proof, first) {
      var cover = first && bundle.kind !== 'colouring' && (config.covers || {})[first.storyId];
      var pose = cover && cover.char;
      var photo = first && first.child && first.child.photoFile;
      if (!offers.rememberBasketPhotoCover || !proof || !photo || !pose) return Promise.resolve();
      return offers.rememberBasketPhotoCover(properties, proof, photo, pose);
    }

    var attaching = false;
    function addToBasket() {
      sync();
      if (editing) {
        if (!editor || editor.phase() !== 'ready' || attaching || guideToMissing()) return;
        var editSlots = core.builderSlots(state, bundle, region);
        var entries = offers.buildBundleProperties(bundle, catalogue, editSlots, region);
        entries.push(['_Photo consent', 'adult-authority-v2026-07-21']);
        if (options.extraProperties) entries = entries.concat(options.extraProperties());
        attaching = true;
        root.querySelectorAll('input, button').forEach(function (node) { node.disabled = true; });
        (cta.buttons || []).forEach(function (node) { if (node) node.textContent = 'Saving…'; });
        var editProof = null;
        return coverProof(config, bundle, editSlots[0]).then(function (proof) {
          editProof = proof;
          if (proof) entries.push(['_Personalised artwork', proof, 'storybook-cover.jpg']);
          return offers.preparePhotoEntries(entries);
        }).then(function (prepared) {
          var properties = {};
          prepared.forEach(function (entry) { if (typeof entry[1] === 'string') properties[entry[0]] = entry[1]; });
          return rememberPhotoCover(properties, editProof, editSlots[0]).then(function () { return prepared; });
        }).then(function (prepared) {
          attaching = false;
          return editor.save(prepared);
        }).catch(uploadFailed);
      }
      if (cart.pending()) { cart.reconcile(); return; }
      if (cart.isAdding() || attaching || guideToMissing()) return;
      var form = new FormData();
      form.append('id', String(bundle.variantId));
      form.append('quantity', '1');
      var builtSlots = core.builderSlots(state, bundle, region);
      offers.buildBundleProperties(bundle, catalogue, builtSlots, region).forEach(function (entry) {
        offers.appendProperty(form, entry);
      });
      form.append('properties[Personalisation]', 'From your photo');
      form.append('properties[_Photo consent]', 'adult-authority-v2026-07-21');
      // The page's own extra lines, e.g. a set's dedication (ll-storybook.js).
      if (options.extraProperties) options.extraProperties().forEach(function (entry) { offers.appendProperty(form, entry); });
      attaching = true; cart.setControls(true, 'Adding…');
      if (options.onChange) options.onChange();
      var addProof = null;
      return coverProof(config, bundle, builtSlots[0]).then(function (proof) {
        addProof = proof;
        if (proof) form.append('properties[_Personalised artwork]', proof, 'storybook-cover.jpg');
        return offers.preparePhotoForm(form);
      }).then(function () {
        return rememberPhotoCover(offers.formProperties ? offers.formProperties(form) : {}, addProof, builtSlots[0]);
      }).then(function () {
        attaching = false;
        return post();
      }).catch(uploadFailed);
      function uploadFailed(error) {
        attaching = false;
        if (editing) showEditPhase(editor ? editor.phase() : 'ready');
        cart.setControls(false);
        render();
        setStatus(addStatus, (error && error.message) || 'We couldn’t save their photo. Please try again.', 'bad');
        /* the journey retires it on the next step (clearAddFailure) */
        if (addStatus) addStatus.setAttribute('data-llsb-add-failure', addStatus.textContent);
        if (options.onChange) options.onChange();
      }
      function post() {
        var attempt = cart.add(form, { onAdded: function () {
          if (offers.trackOffer) offers.trackOffer('confirmed', options.trackContext || { region: region, surface: 'bundle', offerId: bundle.id, placement: 'inline' });
          if (options.onAdded) options.onAdded();
        } });
        if (options.onChange) options.onChange();
        if (attempt && attempt.then) attempt.then(function () { if (options.onChange) options.onChange(); });
        return attempt;
      }
    }
    if (!external) (cta.buttons || []).forEach(function (b) { if (b) b.addEventListener('click', addToBasket); });

    /* ---------- handoff from a PDP (bundle page only) ---------- */
    if (!external && !editing && offers.createHandoffStore) {
      offers.createHandoffStore(offers.indexedDbHandoffDriver()).take().then(function (record) {
        if (!offers.validHandoff(record, bundle.id)) return;
        if (state.primary.photoFile || state.primary.name) return; /* shopper already started typing before this resolved — never overwrite them */
        state.primary.photoFile = record.photo;
        state.primary.name = record.name || '';
        state.primary.consent = record.consent === true;
        state.primary.ready = true;
        if (consentInput) consentInput.checked = state.primary.consent;
        if (nameInput) nameInput.value = state.primary.name;
        var reader = new FileReader();
        reader.onload = function () { state.primary.photoDataUrl = String(reader.result || ''); primaryGate.showReady(state.primary.photoDataUrl); render(); };
        reader.onerror = function () { primaryGate.showReady(null); render(); };
        reader.readAsDataURL(record.photo);
      }).catch(function () {});
    }

    /* a different bundle, same child: the slots are re-derived (the host's
       from-story first), the primary object is kept */
    function setBundle(next) {
      if (editing) return;
      sync();
      savedBundles[bundle.id] = cloneState(state);
      bundle = next;
      var currentPrimary = state.primary;
      state = savedBundles[bundle.id] || core.createState(bundle, catalogue, options.fromStoryId || '', currentPrimary);
      state.primary = currentPrimary;
      dropNote();
      render();
    }

    render();
    if (editing) {
      var editControls = root.querySelector('[data-llbp-edit-controls]');
      if (editControls) editControls.hidden = false;
      var selector = root.querySelector('[data-llbo-summary]');
      if (selector) selector.hidden = true;
      editor = offers.createCartEditor({
        cartUrl: config.cartUrl, variantId: bundle.variantId, region: region,
        validate: function (item) { return Boolean(core.restoreCartItem(item, bundle, catalogue, region)); },
        onStatus: function (phase, message) {
          showEditPhase(phase);
          setStatus(addStatus, message, phase !== 'ready' && phase !== 'loading' && phase !== 'saving' ? 'bad' : '');
        }
      });
      editor.load(editKey).then(function (item) {
        if (!item) return;
        state = core.restoreCartItem(item, bundle, catalogue, region);
        if (state.singleChild) state = core.usePrimaryChild(state);
        root.querySelectorAll('input, button').forEach(function (node) { node.disabled = false; });
        if (nameInput) nameInput.value = state.primary.name;
        if (consentInput) consentInput.checked = state.primary.consent;
        primaryGate.showReady(state.primary.photoDataUrl);
        render();
      });
    } else if (cart.pending()) cart.reconcile();
    if (!external) window.addEventListener('pageshow', function (event) {
      if (!event.persisted) return;
      if (editing) { window.location.reload(); return; }
      cart.reset(); if (cart.pending()) cart.reconcile();
    });

    return {
      setBundle: setBundle,
      render: render,
      isReady: function () { sync(); return core.isReady(state, bundle, catalogue, region); },
      firstMissing: function () { sync(); return core.firstMissing(state, bundle, catalogue, region); },
      guideToMissing: guideToMissing,
      add: addToBasket,
      state: function () { sync(); return state; },
      bundle: function () { return bundle; },
      previewCover: function (container, index, colouring) {
        sync(); container.textContent = '';
        var slot = state.slots[index]; if (!slot) return;
        var colour = colouring && bundle.kind === 'mixed' ? offers.collectionColouring(catalogue, slot, state.slots) : null;
        container.appendChild(colouring ? colouringTile(colour ? Object.assign({}, slot, { storyId: colour.storyId }) : slot) : coverTile(slot));
        fitAllNames();
        if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitAllNames);
      },
      previewBook: function (container, book) {
        container.textContent = '';
        var slot = { storyId: book.storyId };
        container.appendChild(book.colouring ? colouringTile(slot, book.child) : coverTile(slot, book.child));
        fitAllNames();
        if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitAllNames);
      },
      /* Saved choices come back whole or not at all. A picked set may have
         slots still to choose (null). */
      restoreStories: function (ids) {
        if (hasFixedSlots(offers, bundle) || core.pickerMode(bundle) === 'fixed' || !Array.isArray(ids) || ids.length !== state.slots.length) return;
        var chosen = ids.filter(function (id) { return id !== null; });
        if (chosen.length !== ids.length && core.pickerMode(bundle) !== 'pick') return;
        if (new Set(chosen).size !== chosen.length) return;
        if (!chosen.every(function (id) { return typeof id === 'string' && (bundle.kind === 'colouring' ? catalogue.colouring : catalogue.stories).some(function (entry) { return entry.storyId === id; }); })) return;
        state.slots.forEach(function (slot, index) { slot.storyId = ids[index]; }); dropNote(); render();
      },
      chooseStory: function (index, storyId) { state = core.pickStory(state, bundle, catalogue, index, storyId); render(); },
      toggle: toggleBook,
      clear: clearBook,
      busy: function () { return attaching || cart.isAdding() || Boolean(cart.pending()); }
    };
  }

  if (typeof document === 'undefined') return;

  /* ================= bundle product page boot ================= */
  var root = document.querySelector('[data-llbp-root]');
  if (!root) return;

  /* Queried and wired up unconditionally (config/offers/bundle may still
     turn out to be missing) so deadEnd() below always has real buttons and
     a real status line to work with. Captured BEFORE the reparent below:
     once the bar moves to document.body it is no longer inside root, so
     `root.querySelector('[data-llbp-ctabar]')` after that point would
     return null. */
  var addButton = root.querySelector('[data-llbp-add]');
  var addStatus = root.querySelector('[data-llbp-add-status]');
  var stickyAdd = root.querySelector('[data-llbp-add-sticky]');
  var ctabar = root.querySelector('[data-llbp-ctabar]');
  if (ctabar && ctabar.parentNode !== document.body) document.body.appendChild(ctabar); /* fixed bar out of any transformed ancestor, as the colouring page does */

  /* A stale/missing offers module, an unparsable config, or a bundle this
     market doesn't sell must all surface a visible dead end — both buttons
     disabled and relabelled, never a silently inert page. Buttons get the
     short label; the status line gets the full sentence. */
  function deadEnd(message, buttonLabel) {
    [addButton, stickyAdd].forEach(function (b) { if (b) { b.disabled = true; b.textContent = buttonLabel; } });
    if (addStatus) {
      addStatus.hidden = false;
      addStatus.className = 'llsb__upload-status is-bad';
      addStatus.textContent = message;
    }
  }

  var configEl = root.querySelector('[data-llbp-config]');
  if (!configEl || !offers || typeof offers.requiresSingleChild !== 'function') { deadEnd('Sorry — this page didn’t finish loading. Please refresh and try again.', 'Please refresh'); return; }
  var config;
  try { config = JSON.parse(configEl.textContent); } catch (e) { deadEnd('Sorry — this page didn’t finish loading. Please refresh and try again.', 'Please refresh'); return; }
  if (offers.trackConsentClearance) offers.trackConsentClearance(ctabar);
  var bundle = (config.bundles || []).filter(function (b) { return b.id === config.bundleId; })[0];
  if (!bundle) { deadEnd('Not available in this market', 'Not available in this market'); return; }
  var storage = null;
  try { storage = window.localStorage; } catch (e) { storage = null; }
  var fromStoryId = offers.requestedFromStoryId();
  var api = mount(root, {
    config: config, bundle: bundle, offers: offers, fromStoryId: fromStoryId,
    cta: { buttons: [addButton, stickyAdd], status: addStatus, idleLabel: config.ctaLabel, storageKey: 'llbp:' + config.product.handle + ':pending-add', storage: storage },
    trackContext: { region: config.region, surface: 'bundle', offerId: bundle.id, placement: 'builder' }
  });

  /* The selector at the top of the panel: every other option is a link to
     its own page, the child carried through the handoff once ready. The
     single card links to the story this page was reached from (Liquid
     cannot read ?from= — the section is cached — so it is re-pointed here). */
  if (offers.requestedCartEdit(window.location.hash) === null) offers.bindOfferSelector(root, {
    region: config.region, surface: 'bundle', bundles: config.bundles || [],
    /* Another package's page takes the child over (the handoff carries the
       child, never the books), so it asks only that the child is complete:
       a book still to choose here is not a reason to lose their photo. */
    isReady: function () { var missing = api.firstMissing(); return !missing || missing.slotIndex > 0; },
    storyId: fromStoryId,
    child: function () { var p = api.state().primary; return { name: p.name, photoFile: p.photoFile }; }
  });
  var family = bundle.kind === 'colouring' ? (config.catalogue && config.catalogue.colouring) : (config.catalogue && config.catalogue.stories);
  var fromEntry = (family || []).filter(function (entry) { return entry.storyId === fromStoryId; })[0];
  var singleNode = root.querySelector('[data-llbo-option="single"]');
  if (fromEntry && fromEntry.url && singleNode) {
    singleNode.setAttribute('data-llbo-url', fromEntry.url);
    if (singleNode.getAttribute('href')) singleNode.setAttribute('href', fromEntry.url);
  }
}());
